export const translationDe_AT_PPOE = {
translation: {
    entity: {
        job: 'Funktion',
    },
}
}